import React, { useMemo } from 'react';
import propTypes from 'prop-types';
import { UiTableForSars } from 'src/ui';
import Moment from 'moment';

export function SarsTable({ loading, sars }) {
  const tableColumns = useMemo(
    () => [
      {
        Header: 'Fincen Id',
        accessor: 'sarId',
        Cell: row => {
          return <>{row.value ? row.value : row.original.sarId}</>;
        },
      },
      {
        Header: 'Filed By',
        accessor: 'sarFilerName',
        Cell: row => <>{row.value ? row.value : row.original.sarId}</>,
      },
      {
        Header: 'Date Filed',
        accessor: 'sarFiledDate',
        Cell: row => <>{Moment(row.value).format('YYYY/MM/DD')}</>,
      },
    ],
    []
  );

  return (
    <>
      <UiTableForSars
        columns={tableColumns}
        loading={loading}
        data={sars}
        title="SAR"
        resolveData={data =>
          data.map(sars => ({
            ...sars,
          }))
        }
        getTheadThProps={(_state, _rowInfo, column) => ({
          className: ['id', 'sarFilerName', 'sarFiledDate'].includes(column.id)
            ? 'has-text-left'
            : '',
        })}
        toNext="/people"
        toPrev="/business"
        hideNext
        hidePrev
      />
    </>
  );
}

SarsTable.propTypes = {
  loading: propTypes.bool.isRequired,
  sars: propTypes.arrayOf(propTypes.object).isRequired,
};
